export default "__VITE_ASSET__DzO_W_Ka__"